import { Hash } from "@elas_co/ts";
import bcrypt from "bcryptjs";

export function notFound(res, details) {
  return res.status(200).json({
    error: "Function not found",
    details,
  });
}
const { genSaltSync, hashSync, compareSync } = bcrypt;

const saltRounds = 13; // unlucky #13?
export function hashPassword(password) {
  //console.log('hashing...')
  const salt = genSaltSync(saltRounds);
  return hashSync(password, salt);
}

export function sha256Hash(message) {
  return Hash.sha256(Buffer.from(message)).toString("hex");
}
// Bcrypt verifying
export function verifyPassword(userPasswordHash, password) {
  if (!password || !userPasswordHash) return false;
  return compareSync(password, userPasswordHash); // Throws error if args undefined hence above if->false
}

// take only needed user fields to avoid sensitive ones (such as password)
export function secureUserObject(user) {
  if (user) {
    const varsToDelete = [
      "_id",
      "secure",
      "dateOfBirth",
      "country",
      "createdAt",
    ];
    varsToDelete.map((v) => {
      delete user[v];
    });
  }
  return user || null;
}

export const securePostData = (expectedData, req) => {
  try {
    const bodyFields = Object.keys(req?.body);
    const expectedFields = Object.keys(expectedData);
    // Delete everything we are not expecting and check types on those we are
    bodyFields.map((key) => {
      if (!expectedFields.includes(key)) {
        // If not expected
        delete req?.body[key]; // Delete the thing?
        // Should we record instances of this and ban users?
        // throw new Error(`Invalid post data variable ${key}, type ${ typeof req?.body[key]} for ${req?.url} by user: ${req?.user?.username}`) // Or the wrong type throw an error
      } else {
        if (expectedData[key] !== typeof req?.body[key]) {
          // Otherwise if expected data is wrong type
          throw new Error(
            `Incorrect post data ${key}, type ${typeof req?.body[key]} for ${
              req?.url
            } by user: ${req?.user?.username}`
          ); // Or the wrong type throw an error
        }
      }
    }); // No errors thrown, so data is good
    req.body.error = undefined;
  } catch (err) {
    console.log({ err });
    req.body.error = err;
  }
  return req?.body;
};

// Could do a full typeof scan but this will do for now (until needed)
export const sanitiseAndSecureObjectId = (obj, stripId) => {
  // console.log({ obj, stripId })
  if (stripId) {
    delete obj._id;
    return obj;
  } else return JSON.parse(JSON.stringify(obj)); // weird step needed for sanitizing ObjectIds
};

// Could do a full typeof scan but this will do for now (until needed)
export const sanAndSecObjectIdArray = (objArray, secure) => {
  return objArray.map((o) => {
    return sanitiseAndSecureObjectId(o, secure);
  });
};

export const isUserAdmin = (req) => {
  if (req?.user?.role !== accountTypes.admin.level) {
    console.log({ ERROR: "Non-admin reached admin page" });
    return false;
  }
  return true;
};

export const parseIp = (req) =>
  req.headers["x-forwarded-for"]?.split(",").shift() ||
  req.socket?.remoteAddress ||
  "Unknown";

// throws error if user role not greater than supplied role
export const checkRoutePrivilege = (req, minAccessLevel) => {
  // console.log('checkRoutePrivilege')
  // NOTE: accountType is specifically not checked below as this is just what the user has signed up as,
  // not what they are currently. role is what they are currently.
  if (req.user?.role < minAccessLevel) {
    const error = `User: ${req.user?.username}@${parseIp(
      req
    )} with accountType: ${accountTypeLabelByLevel(
      req?.user?.role || 0
    ).toUpperCase()} hit endpoint: ${req?.url} without privilege`;
    // console.log({ error })
    return {
      error,
    };
  }
  return true;
};
